module.exports = __webpack_public_path__ + "static/img/org_title4.5d87b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/org_title4.png
// module id = doKo
// module chunks = 4